import React, { Component } from 'react';
import SmoothScrollbar from 'react-smooth-scrollbar';
import {registerScrollbar, unregisterScrollbar} from './ScrollObserver'

class Scrollbar extends Component {
	componentDidMount() {
		if(this.props.register) registerScrollbar(this.scrollbar)
	}
	componentWillUnmount() {
		if(this.props.register) unregisterScrollbar(this.scrollbar)
	}
	render() {
		return (
			<SmoothScrollbar 
				ref={c => this.scrollbar = c}
				syncCallbacks={false}
				renderByPixels={true}
				overscrollEffect='bounce'>
        		{this.props.children}
        	</SmoothScrollbar>
        )
	}
}

export default Scrollbar;



// WEBPACK FOOTER //
// ./src/fm/lib/Scrollbar.js